import { render } from "./TopComponent.vue?vue&type=template&id=58f1fe40&scoped=true"
import script from "./TopComponent.vue?vue&type=script&lang=js"
export * from "./TopComponent.vue?vue&type=script&lang=js"

import "./TopComponent.vue?vue&type=style&index=0&id=58f1fe40&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f1fe40"]])

export default __exports__